var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0.75C23.2617 0.75 30 7.48828 30 15.75C30 24.0703 23.2617 30.75 15 30.75C6.67969 30.75 0 24.0703 0 15.75C0 7.48828 6.67969 0.75 15 0.75ZM15 8.25C12.6562 8.25 10.7812 10.1836 10.7812 12.4688C10.7812 14.8125 12.6562 16.6875 15 16.6875C17.2852 16.6875 19.2188 14.8125 19.2188 12.4688C19.2188 10.1836 17.2852 8.25 15 8.25ZM15 27C18.0469 27 20.8594 25.7695 22.9102 23.7188C21.9727 21.2578 19.6289 19.5 16.875 19.5H13.125C10.3125 19.5 7.96875 21.2578 7.03125 23.7188C9.08203 25.7695 11.8945 27 15 27Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user-circle.7d1cf7fe56bf2f32cd2e2500679b2b2f.svg";
export { ForwardRef as ReactComponent };